import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Financial Module Service Stores
 */
export const financialStores: ServiceStoreConfig[] = [
  {
    name: "invoices",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          const store = rootStore.invoicesStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalInvoices = entities.length;
          const unpaidInvoices = entities.filter(
            (invoice: Record<string, unknown>) =>
              invoice.status === "unpaid" || invoice.status === "pending"
          ).length;
          const overdueInvoices = entities.filter(
            (invoice: Record<string, unknown>) => {
              const dueDate = new Date(invoice.dueDate as string);
              return dueDate < new Date() && invoice.status !== "paid";
            }
          ).length;
          const totalAmount = entities.reduce(
            (sum: number, invoice: Record<string, unknown>) => {
              return (
                sum +
                ((invoice.amount as number) || (invoice.total as number) || 0)
              );
            },
            0
          );

          return [
            {
              title: "Total Invoices",
              value: () => totalInvoices.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Unpaid",
              value: () => unpaidInvoices.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Overdue",
              value: () => overdueInvoices.toString(),
              valueColor: "error.main",
            },
            {
              title: "Total Amount",
              value: () => `$${((totalAmount as number) / 1000).toFixed(0)}K`,
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  {
    name: "bills",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "payments",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "tax-rates",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "chart-of-accounts",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "journal-entries",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "financial-reports",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  // New backend services - change orders
  {
    name: "change-orders",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  {
    name: "change-order-line-items",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  {
    name: "change-order-attachments",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  // Purchase order approvals support service
  {
    name: "purchase-order-approvals",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
];